import { render, staticRenderFns } from "./wxworkanalysis.vue?vue&type=template&id=7f38773a&scoped=true&"
import script from "./wxworkanalysis.vue?vue&type=script&lang=js&"
export * from "./wxworkanalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f38773a",
  null
  
)

export default component.exports